<script lang="ts">
import { defineComponent, inject } from "vue";
import { computed } from "vue";

export default defineComponent({
  name: "InfoBox",
  components: {},
  props: {
    id: String,
  },
  setup(props) {
    const istSichtbar: any = inject("istSichtbar");

    const anzeigen = computed(() => {
      return istSichtbar(props.id);
    });

    return {
      anzeigen,
    };
  },
});
</script>

<template>
  <div v-if="anzeigen" class="notice-box" :id="id">
    <p style="margin-top: 0 !important">
      <slot></slot>
    </p>
  </div>
</template>
